/**
 * @generated by bin/generate-passkey-setup-apps.js — never edit by hand. The apps that set a passkey up (SECREQ
 * S6d): each whose `src/routes/passkey.js` mounts `createPasskeyRouter` with an `enrollment`, by registry key. A
 * held person in any other app is handed to one of these (owner ruling Q5).
 *
 * @module @puffin-core/factor-enrollment-codes/passkeySetupApps
 */

'use strict';

/** @constant {ReadonlyArray<string>} */
const PASSKEY_SETUP_APP_KEYS = Object.freeze([
  'palm',
  'parcel',
  'patrol',
  'payday',
  'planner',
  'prep',
  'purchase',
]);

module.exports = { PASSKEY_SETUP_APP_KEYS };
